export default "__VITE_ASSET__DXbe2lSN__"